export const getSwitchConfigurationConfirmationDescription = configurationName =>
  `Switch to ${configurationName}? This starts a new conversation.`;
